import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_CommunityBasedServicesAuthorizationRequestForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_CommunityBasedServicesAuthorizationRequestForm' className='file-pdf-document'>
            <div className='file-template'>


                <h3>Member's Freedom of Choice</h3>
                <table>
                    <tr>
                        <td className='w-250'>Magellan in Louisiana</td>
                        <td className='w-250'>Fax to 1-888-656-5325</td>
                        <td className='w-250'>Freedom of Choice Form</td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                </table>
                <p className='w-750'>I am aware that providers and facilities available to me can be found, within the Members tab and Provider Search, on the Magellan of Louisiana website (<b>www.magellanoflouisiana.com</b>).</p>
                <p className='w-750'>
                    <span className='eleHeader'>The provider I choose is</span>
                    <span className='small'>(enter provider name and phone number in box)</span>
                    <textarea id='txtProvNameAndPhoneNum' name='txtProvNameAndPhoneNum' className='add-only'></textarea>
                </p>
                <p className='w-750'>By signing below, I acknowledge that I freely choose to receive services from the above provider, and I acknowledge my responsibility to notify my previous provider in order to coordinate care. (member signature in box),</p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Name</span>
                            <input type='text' id='txtMemberName' name='txtMemberName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Date of Birth</span>
                            <input type='date' id='txtMemberDOB' name='txtMemberDOB' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='signature w-350'>&nbsp; </td>
                        <td className='signature w-350'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-350'> Member/Legal Guardian Signature</td>
                        <td className='small w-350'> Legal Guardian Name</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Today's Date</span>
                            <input type='date' id='txtTodayDate' name='txtTodayDate' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Instructions for Provider</h4></p>
                <p className='w-750'>A Freedom of Choice Form is required prior to service authorizations.
                    The form requires a member signature, date, an identified provider and provider telephone number.
                    This provider assumes responsibility of coordinating care with the prior provider of record.
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Provider Representative Signature</td>
                    </tr>
                </table>

                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    <span className='eleHeader'>Community Based Services Authorization Request</span>
                    <span className='small'>(Check Services Being Requested)</span>
                    Email may be used to communicate regarding missing & incomplete information, but not for notice of authorizations. Please check your provider website for authorization information.
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCbsar_Act21' name='cbCbsar' className='add-only' value='Act21' /> ACT (21+)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCbsar_Cpst21' name='cbCbsar' className='add-only' value='Cpst_21' /> CPST (21+)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCbsar_Psr21Individual' name='cbCbsar' className='add-only' value='Psr_21' /> PSR (21+) Individual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCbsar_Psr21Group' name='cbCbsar' className='add-only' value='PsrGroup' /> PSR (21+) Group
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCbsar_Mst1217' name='cbCbsar' className='add-only' value='Mst' /> MST (12-17)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCbsar_CpstUnder21' name='cbCbsar' className='add-only' value='CpstPsr' /> CPST/PSR (under 21)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCbsar_Homebuilders018' name='cbCbsar' className='add-only' value='Homebuilders' /> Homebuilders (0-18)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCbsar_Fft1018' name='cbCbsar' className='add-only' value='Fft' /> FFT (10-18)
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Last Name</span>
                            <input type='text' id='txtCbsar_MembLastName' name='txtCbsar_MembLastName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>First</span>
                            <input type='text' id='txtCbsar_MembFirstName' name='txtCbsar_MembFirstName' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Initial Request</span>
                            <input type='date' id='txtCbsar_DateOfInitialRequest' name='txtCbsar_DateOfInitialRequest' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Concurrent Review</span>
                            <select id='ddlCbsar_ConcurrentReview' name='ddlCbsar_ConcurrentReview' className='add-only'>
                                <option value='Na'></option>
                                <option value='1'>1</option>
                                <option value='2'>2</option>
                                <option value='3'>3</option>
                                <option value='4'>4</option>
                                <option value='5'>5</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Funding Source</span>
                            <select id='ddlCbsar_FundingSource' name='ddlCbsar_FundingSource' className='add-only'>
                                <option value='Na'></option>
                                <option value='Medicaid'>Medicaid</option>
                                <option value='Obh'>OBH</option>
                                <option value='Unk'>UNK</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>SSN</span>
                            <input type='text' id='txtCbsar_Ssn' name='txtCbsar_Ssn' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medicaid Number</span>
                            <input type='text' id='txtCbsar_MedicaidNumber' name='txtCbsar_MedicaidNumber' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Birth</span>
                            <input type='date' id='txtCbsar_MemberDob' name='txtCbsar_MemberDob' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If Adult Medicaid, is Independent Assessment Completed and 1915i eligibility determined?</span>
                    <span className='small'>(If No, authorization cannot be completed.)</span>
                    <select id='ddlCBSAR_AdultMedicaid' name='ddlCBSAR_AdultMedicaid' className='add-only'>
                        <option value='Na'></option>
                        <option value='Yes'>Yes</option>
                        <option value='No'>No</option>
                    </select>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>For ALL NEW requests, is Freedom of Choice Form Completed?</span>
                    <span className='small'>(If No, authorization cannot be completed.)</span>
                    <select id='ddlCBSAR_AllNewRequests' name='ddlCBSAR_AllNewRequests' className='add-only'>
                        <option value='Na'></option>
                        <option value='Yes'>Yes</option>
                        <option value='No'>No</option>
                    </select>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Legal Guardian</span>
                            <input type='text' id='txtLegGuard_Name' name='txtLegGuard_Name' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Guardian Address</span>
                            <input type='text' id='txtLegGuard_Address' name='txtLegGuard_Address' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                            <input type='text' id='txtLegGuard_Phone' name='txtLegGuard_Phone' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Cell Phone</span>
                            <input type='text' id='txtLegGuard_CellPhone' name='txtLegGuard_CellPhone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider</span>
                            <input type='text' id='txtProvider_Name' name='txtProvider_Name' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span>
                            <input type='text' id='txtProvider_Phone' name='txtProvider_Phone' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>MIS #</span>
                            <input type='text' id='txtProvider_MISNum' name='txtProvider_MISNum' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Fax</span>
                            <input type='text' id='txtProvider_Fax' name='txtProvider_Fax' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name & Credentials</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Email</span>
                            <span className='small'>(Email may be used to communicate regarding missing & incomplete information, but not for notice of authorizations.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProvider_NameCredentials' name='txtProvider_NameCredentials' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtProvider_Email' name='txtProvider_Email' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Member Demographics</h4></p>
                <p className='w-750'>Please complete the following demographic information relating to the member</p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Gender</span>
                            <select id='ddlMemDemo_Gender' name='ddlMemDemo_Gender' className='add-only'>
                                <option value='Na'></option>
                                <option value='Male'>Male</option>
                                <option value='Female'>Female</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Pregnant</span>
                            <select id='ddlMemDemo_Pregnant' name='ddlMemDemo_Pregnant' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Single Parent</span>
                            <select id='ddlMemDemo_SingleParent' name='ddlMemDemo_SingleParent' className='add-only'>
                                <option value='None'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                                <option value='Na'>N/A</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>IV Drug User</span>
                            <select id='ddlMemDemo_IVDrugUser' name='ddlMemDemo_IVDrugUser' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance use while pregnant</span>
                            <select id='ddlMemDemo_WhilePregnant' name='ddlMemDemo_WhilePregnant' className='add-only'>
                                <option value='None'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                                <option value='Na'>N/A</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Does Mbr have PCP</span>
                            <select id='ddlMemDemo_MbrHavePCP' name='ddlMemDemo_MbrHavePCP' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Relationship Status</span>
                            <select id='ddlMemDemo_RelStatus' name='ddlMemDemo_RelStatus' className='add-only'>
                                <option value='Na'></option>
                                <option value='Married'>Married</option>
                                <option value='Divorced'>Divorced</option>
                                <option value='Domestic Partner'>Domestic Partner</option>
                                <option value='Widow(er)'>Widow(er)</option>
                                <option value='Never Married'>Never Married</option>
                                <option value='Unknown'>Unknown</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Race</span>
                            <select id='ddlMemDemo_Race' name='ddlMemDemo_Race' className='add-only'>
                                <option value='Na'></option>
                                <option value='White/Caucasian'>White/Caucasian</option>
                                <option value='Asian'>Asian</option>
                                <option value='American Indian'>American Indian</option>
                                <option value='Alaskan'>Alaskan</option>
                                <option value='HI/Pacific Islander'>HI/Pacific Islander</option>
                                <option value='Black/African-American'>Black/African-American</option>
                                <option value='Other'>Other</option>
                                <option value='Unknown'>Unknown</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Ethnicity</span>
                            <select id='ddlMemDemo_Ethnicity' name='ddlMemDemo_Ethnicity' className='add-only'>
                                <option value='Na'></option>
                                <option value='Cent/So American'>Cent/So American</option>
                                <option value='Mex/Mex American'>Mex/Mex American</option>
                                <option value='Cuban'>Cuban</option>
                                <option value='Puerto Rican'>Puerto Rican</option>
                                <option value='Non-Hisp or Non Latino'>Non-Hisp or Non Latino</option>
                                <option value='Hispanic/Latino'>Hispanic/Latino</option>
                                <option value='Hisp/Latin unk origin'>Hisp/Latin unk origin</option>
                                <option value='Unknown'>Unknown</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Admission Driver</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_ER' name='cbAdmDriver' className='add-only' value='ER' /> ER
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_Psychiatrist' name='cbAdmDriver' className='add-only' value='Psychiatrist' /> Psychiatrist
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_Police' name='cbAdmDriver' className='add-only' value='Police' /> Police
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_Therapist' name='cbAdmDriver' className='add-only' value='Therapist' /> Therapist
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_Probation' name='cbAdmDriver' className='add-only' value='Probation' /> Probation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_PCP' name='cbAdmDriver' className='add-only' value='Pcp' /> PCP
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_GroupHome' name='cbAdmDriver' className='add-only' value='GroupHome' /> Group Home
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_ActTeam' name='cbAdmDriver' className='add-only' value='ActTeam' /> ACT Team
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_School' name='cbAdmDriver' className='add-only' value='School' /> School
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_Corrections' name='cbAdmDriver' className='add-only' value='Corrections' /> Corrections
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_ClinicalTeam' name='cbAdmDriver' className='add-only' value='ClinicalTeam' /> Clinical Team
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_CST' name='cbAdmDriver' className='add-only' value='ChildFamilyTeam' /> Child & Family Team (CST)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_MedicalHospital' name='cbAdmDriver' className='add-only' value='MedicalHospital' /> Medical Hospital
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_PGFF' name='cbAdmDriver' className='add-only' value='ParentGuardianFamilyFriend' /> Parent/guardian/family/friend
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_FosterCareProgram' name='cbAdmDriver' className='add-only' value='FosterCareProgram' /> Foster Care Program
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_YouthSvc' name='cbAdmDriver' className='add-only' value='ChildrenYouthSvc' /> Children & Youth Svc
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_SpecialThxFstrCare' name='cbAdmDriver' className='add-only' value='SpecialThxFstrCare' /> Special Thx Fstr Care
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdmDriver_NA' name='cbAdmDriver' className='add-only' value='Na' /> N/A
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Referring Agency</span>
                            <select id='ddlReferringAgency' name='ddlReferringAgency' className='add-only'>
                                <option value='None'></option>
                                <option value='Ojj'>OJJ</option>
                                <option value='Doe'>DOE</option>
                                <option value='Obh'>OBH</option>
                                <option value='Dcfs'>DCFS</option>
                                <option value='Na'>N/A</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Child involved with agency</span>
                            <select id='ddlChildInvolvedWithAgency' name='ddlChildInvolvedWithAgency' className='add-only'>
                                <option value='None'></option>
                                <option value='Ojj'>OJJ</option>
                                <option value='Doe'>DOE</option>
                                <option value='Dcfs'>DCFS</option>
                                <option value='Na'>N/A</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Presenting Problem</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreProblem_AlcoholDrug' name='cbPreProblem' className='add-only' value='AlcoholDrug' /> Alcohol/Drug
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreProblem_MedicalPhysical' name='cbPreProblem' className='add-only' value='MedicalPhysical' /> Medical/Physical
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreProblem_FamilyChildren' name='cbPreProblem' className='add-only' value='FamilyChildren' /> Family/Children
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreProblem_MoodDepression' name='cbPreProblem' className='add-only' value='MoodDepression' /> Mood/Depression
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreProblem_OtherEmot' name='cbPreProblem' className='add-only' value='OthersEmotHealth' /> Other's Emot/Health
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreProblem_DangerToSelf' name='cbPreProblem' className='add-only' value='DangerSelfOthers' /> Danger to Self/Others
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreProblem_TraumaDisaster' name='cbPreProblem' className='add-only' value='TraumaDisaster' /> Trauma/Disaster
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreProblem_SevrImprmnt' name='cbPreProblem' className='add-only' value='Sevr ImprmntGravelyDisabled' /> Sevr Imprmnt/Gravely Disabled
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Type of residence</span>
                            <select id='ddlTypeOfResidence' name='ddlTypeOfResidence' className='add-only'>
                                <option value='Na'></option>
                                <option value='Home'>Home</option>
                                <option value='Homeless'>Homeless</option>
                                <option value='Board & Care'>Board & Care</option>
                                <option value='Shelter'>Shelter</option>
                                <option value='Residential Hotel'>Residential Hotel</option>
                                <option value='No Residence'>No Residence</option>
                                <option value='Single Family Dwelling'>Single Family Dwelling</option>
                                <option value='Foster Home'>Foster Home</option>
                                <option value='Group Home/Halfway'>Group Home/Halfway</option>
                                <option value='Prvt Resd-W/Fmly/Ext Fmly/NR'>Prvt Resd-W/Fmly/Ext Fmly/NR</option>
                                <option value='Unknown'>Unknown</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Veteran Status</span>
                            <select id='ddlVeteranStatus' name='ddlVeteranStatus' className='add-only'>
                                <option value='Na'></option>
                                <option value='Yes'>Yes</option>
                                <option value='No'>No</option>
                                <option value='Unk'>Unk</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Clinical Information</span>
                            <span className='small'><b>Identified Client Abilities, Aptitudes, Skills, and Strengths</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_FamilySupport' name='cbCliInfo' className='add-only' value='FamilySupport' /> Family Support
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_GoodSelfCare' name='cbCliInfo' className='add-only' value='GoodSelfCare' /> Good Self Care
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_HandicraftSkills' name='cbCliInfo' className='add-only' value='HandicraftSkills' /> Handicraft Skills
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_CapacityForInsight' name='cbCliInfo' className='add-only' value='CapacityInsight' /> Capacity for Insight
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_ShowsConcernForOthers' name='cbCliInfo' className='add-only' value='ShowsConcernOthers' /> Shows Concern for Others
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_EnjoysMusic' name='cbCliInfo' className='add-only' value='EnjoysMusic' /> Enjoys Music
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_AdequateIntelligence' name='cbCliInfo' className='add-only' value='AdequateIntelligence' /> Adequate Intelligence
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_AbilityToStandUp' name='cbCliInfo' className='add-only' value='AbilityStandUpOwnRights' /> Ability to Stand Up for Own Rights
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_MusicalInstrument' name='cbCliInfo' className='add-only' value='PlaysMusicalInstrument' /> Plays a Musical Instrument
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_AdequateVerbalSkills' name='cbCliInfo' className='add-only' value='AdequateVerbalSkills' /> Adequate Verbal Skills
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_GoodPhysicalHealth' name='cbCliInfo' className='add-only' value='GoodPhysicalHealth' /> Good Physical Health
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_ExpressFeelings' name='cbCliInfo' className='add-only' value='AbilityExpressFeelings' /> Ability to Express Feelings
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_GoodSelfEsteem' name='cbCliInfo' className='add-only' value='GoodSelfEsteem' /> Good Self Esteem
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_MakeDecisions' name='cbCliInfo' className='add-only' value='AbilityMakeDecisions' /> Ability to Make Decisions
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_PositiveCulturalIdentity' name='cbCliInfo' className='add-only' value='PositiveCulturalIdentity' /> Positive Cultural Identity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_Imagination' name='cbCliInfo' className='add-only' value='ImaginationCreativity' /> Imagination and Creativity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCliInfo_EnjoysReading' name='cbCliInfo' className='add-only' value='EnjoysReading' /> Enjoys Reading
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCliInfo_Other' name='cbCliInfo' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtCliInfo_Other' name='txtCliInfo_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Diagnostics</h4></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Axis I: (Primary Dx) Enter specific Dx Code in blank</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_Adhds' name='cbAxisI_Adhds' className='add-only' value='Adhds' /> ADHDs &nbsp;
                            <input type='text' id='txtAxisI_Adhds' name='txtAxisI_Adhds' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_SchizoDos' name='cbAxisI_SchizoDos' className='add-only' value='SchizoDos' /> Schizo-DOs &nbsp;
                            <input type='text' id='txtAxisI_SchizoDos' name='txtAxisI_SchizoDos' className='add-only w-200 custom-add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_DisruptiveBxDo' name='cbAxisI_DisruptiveBxDo' className='add-only' value='DisruptiveBxDo' /> Disruptive Bx DO &nbsp;
                            <input type='text' id='txtAxisI_DisruptiveBxDo' name='txtAxisI_DisruptiveBxDo' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_AnxietyDos' name='cbAxisI_AnxietyDos' className='add-only' value='AnxietyDos' /> Anxiety DOs &nbsp;
                            <input type='text' id='txtAxisI_AnxietyDos' name='txtAxisI_AnxietyDos' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_BipolarDos' name='cbAxisI_BipolarDos' className='add-only' value='BipolarDos' /> Bipolar DOs &nbsp;
                            <input type='text' id='txtAxisI_BipolarDos' name='txtAxisI_BipolarDos' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_AdjustmentDo' name='cbAxisI_AdjustmentDo' className='add-only' value='AdjustmentDo' /> Adjustment DO &nbsp;
                            <input type='text' id='txtAxisI_AdjustmentDo' name='txtAxisI_AdjustmentDo' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_DepressDos' name='cbAxisI_DepressDos' className='add-only' value='DepressDos' /> Depress DOs &nbsp;
                            <input type='text' id='txtAxisI_DepressDos' name='txtAxisI_DepressDos' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_OppDefDo' name='cbAxisI_OppDefDo' className='add-only' value='OppDefDo' /> Opp Def DO &nbsp;
                            <input type='text' id='txtAxisI_OppDefDo' name='txtAxisI_OppDefDo' className='add-only w-200 custom-add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_Ptsd' name='cbAxisI_Ptsd' className='add-only' value='Ptsd' /> PTSD &nbsp;
                            <input type='text' id='txtAxisI_Ptsd' name='txtAxisI_Ptsd' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_PsychoticDo' name='cbAxisI_PsychoticDo' className='add-only' value='PsychoticDo' /> Psychotic DO &nbsp;
                            <input type='text' id='txtAxisI_PsychoticDo' name='txtAxisI_PsychoticDo' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_ConductDo' name='cbAxisI_ConductDo' className='add-only' value='ConductDo' /> Conduct DO &nbsp;
                            <input type='text' id='txtAxisI_ConductDo' name='txtAxisI_ConductDo' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAxisI_Deferred' name='cbAxisI_Deferred' className='add-only' value='Deferred' /> Deferred &nbsp;
                            <input type='text' id='txtAxisI_Deferred' name='txtAxisI_Deferred' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAxisI_Other' name='cbAxisI' className='add-only' value='Other' /> Other (or 2nd DX):
                            <input type='text' id='txtAxisI_Other' name='txtAxisI' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Axis II</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisII_BordPersonalityDo' name='cbAxisII_BordPersonalityDo' className='add-only' value='Borderline Personality Do' /> Borderline Personality DO
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisII_MentalRetardation' name='cbAxisII_MentalRetardation' className='add-only' value='Mental Retardation' /> Mental Retardation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisII_AntisocialPersonalityDo' name='cbAxisII_AntisocialPersonalityDo' className='add-only' value='Antisocial Personality Do' /> Antisocial Personality DO
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisII_Defer' name='cbAxisII_Defer' className='add-only' value='Defer' /> Defer
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAxisII_Other' name='cbAxisII_Other' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtAxisII_Other' name='txtAxisII_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Axis III</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIII_Hypertension' name='cbAxisIII_Hypertension' className='add-only' value='Hypertension' /> Hypertension
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIII_Obesity' name='cbAxisIII_Obesity' className='add-only' value='Obesity' /> Obesity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIII_Asthma' name='cbAxisIII_Asthma' className='add-only' value='Asthma' /> Asthma
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIII_Diabetes' name='cbAxisIII_Diabetes' className='add-only' value='Diabetes' /> Diabetes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIII_SeizureDo' name='cbAxisIII_SeizureDo' className='add-only' value='Seizure Do' /> Seizure DO
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIII_Defer' name='cbAxisIII_Defer' className='add-only' value='Defer' /> Defer
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAxisIII_Other' name='cbAxisIII_Other' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtAxisIII_Other' name='txtAxisIII_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Axis IV</span>
                            <span className='small'><b>Problems related to -</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIV_PrimarySupport' name='cbAxisIV_PrimarySupport' className='add-only' value='Primary Support' /> Primary Support
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIV_SocialEnvironment' name='cbAxisIV_SocialEnvironment' className='add-only' value='Social Environment' /> Social Environment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIV_EducationalAchievement' name='cbAxisIV_EducationalAchievement' className='add-only' value='Educational Achievement' /> Educational Achievement
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIV_Occupation' name='cbAxisIV_Occupation' className='add-only' value='Occupation' /> Occupation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIV_Housing' name='cbAxisIV_Housing' className='add-only' value='Housing' /> Housing
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIV_Economic' name='cbAxisIV_Economic' className='add-only' value='Economic/Financial' /> Economic/Financial
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIV_AccessToHealthCare' name='cbAxisIV_AccessToHealthCare' className='add-only' value='Access to Health Care' /> Access to Health Care
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIV_Legal' name='cbAxisIV_Legal' className='add-only' value='Legal' /> Legal
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAxisIV_Defer' name='cbAxisIV_Defer' className='add-only' value='Defer' /> Defer
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAxisIV_Other' name='cbAxisIV_Other' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtAxisIV_Other' name='txtAxisIV_Other' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Axis V: GLOBAL ASSESSMENT OF FUNCTIONING (GAF)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            HIGHEST GAF PAST YEAR: <input type='text' id='txtAxisV_HigGAFPastYr' name='txtAxisV_HigGAFPastYr' className='add-only w-180 custom-add-only' />
                            &nbsp;&nbsp; CURRENT GAF: <input type='text' id='txtAxisV_CurrGAF' name='txtAxisV_CurrGAF' className='add-only w-180 custom-add-only' />
                            &nbsp;&nbsp; <input type='checkbox' id='cbAxisV_Defer' name='cbAxisV_Defer' className='add-only' value='Defer' /> Defer
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Current Medications and Dose</span></td>
                        <td className='w-375'><span className='eleHeader'>Targeted Symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrMedAndDose1' name='txtCurrMedAndDose1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTargetedSymptoms1' name='txtTargetedSymptoms1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrMedAndDose2' name='txtCurrMedAndDose2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTargetedSymptoms2' name='txtTargetedSymptoms2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrMedAndDose3' name='txtCurrMedAndDose3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTargetedSymptoms3' name='txtTargetedSymptoms3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrMedAndDose4' name='txtCurrMedAndDose4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTargetedSymptoms4' name='txtTargetedSymptoms4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrMedAndDose5' name='txtCurrMedAndDose5' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTargetedSymptoms5' name='txtTargetedSymptoms5' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Psychiatric Hospitalizations within past 6 months</span>
                            <select id='ddlPsyHospPast6Mth' name='ddlPsyHospPast6Mth' className='add-only'>
                                <option value='Na'></option>
                                <option value='0'>0</option>
                                <option value='1'>1</option>
                                <option value='2'>2-3</option>
                                <option value='4'>4-5</option>
                                <option value='6'>6+</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Other MH/SA Services</span>
                    <span className='small'><b>Describe previous OP MH/SA services prior to this request. Was the member engaged? Were they successful?</b></span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSAServ_NoPrevOutpat' name='cbSAServ_NoPrevOutpat' className='add-only' value='No previous Outpatient Services have been provided' /> No previous Outpatient Services have been provided.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'><span className='eleHeader'>&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Agency/Provider</span></td>
                        <td className='w-150'><span className='eleHeader'>Dates</span></td>
                        <td className='w-250'><span className='eleHeader'>Client Report of Successful Outcome</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            Routine OutPt
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAgencyRoutOutPt_1' name='txtAgencyRoutOutPt_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesRoutOutPt_1' name='txtDatesRoutOutPt_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClntRptRoutOutPt_1' name='txtClntRptRoutOutPt_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            Routine OutPt
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAgencyRoutOutPt_2' name='txtAgencyRoutOutPt_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesRoutOutPt_2' name='txtDatesRoutOutPt_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClntRptRoutOutPt_2' name='txtClntRptRoutOutPt_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            Routine OutPt
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAgencyRoutOutPt_3' name='txtAgencyRoutOutPt_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesRoutOutPt_3' name='txtDatesRoutOutPt_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClntRptRoutOutPt_3' name='txtClntRptRoutOutPt_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            Routine OutPt
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAgencyRoutOutPt_4' name='txtAgencyRoutOutPt_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesRoutOutPt_4' name='txtDatesRoutOutPt_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClntRptRoutOutPt_4' name='txtClntRptRoutOutPt_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>CPST/PSR</td>
                        <td className='w-250'>
                            <input type='text' id='txtAgency_Cpst' name='txtAgency_Cpst' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDates_Cpst' name='txtDates_Cpst' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClntRpt_Cpst' name='txtClntRpt_Cpst' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Other OJJ/ Probation/Parole</td>
                        <td className='w-250'>
                            <input type='text' id='txtAgency_OtherOJJ' name='txtAgency_OtherOJJ' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDates_OtherOJJ' name='txtDates_OtherOJJ' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClntRpt_OtherOJJ' name='txtClntRpt_OtherOJJ' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Severe Symptoms</h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>Most recent behaviors and duration (describe) include risk of harm</span>
                    <textarea id='txtSevereSymptoms' name='txtSevereSymptoms' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Activities of Daily Living</h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Strengths</span>
                    <textarea id='txtActOfDailyLiv_CurrStrengths' name='txtActOfDailyLiv_CurrStrengths' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current Weaknesses</span>
                    <textarea id='txtActOfDailyLiv_CurrWeaknesses' name='txtActOfDailyLiv_CurrWeaknesses' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Funcitonal Impairment</h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>School</span>
                    <textarea id='txtFuncImp_School' name='txtFuncImp_School' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Home</span>
                    <textarea id='txtFuncImp_Home' name='txtFuncImp_Home' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Community</span>
                    <textarea id='txtFuncImp_Community' name='txtFuncImp_Community' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Member Goals</h3></p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the member's goals for him/herself?</span>
                    <textarea id='txtMemGoals_Him' name='txtMemGoals_Him' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are the goals of the family?</span>
                    <textarea id='txtMemGoals_Family' name='txtMemGoals_Family' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other Supports</span>
                    <span className='small'>(Family, support groups, natural supports)</span>
                    <textarea id='txtOtherSupports' name='txtOtherSupports' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Collaboration</span>
                    <span className='small'>Are you working with another agency, school, or CSOC on behalf of the member?</span>
                    <textarea id='txtCollaboration' name='txtCollaboration' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge/Transition Plan</span>
                    <span className='small'>What is the timeline for the member to achieve treatment goals? What is the referral plan upon discharge?</span>
                    <textarea id='txtTransitionPlan' name='txtTransitionPlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other Notes as Appropriate</span>
                    <textarea id='txtOtherNotesAsAppropriate' name='txtOtherNotesAsAppropriate' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>Concurrent Review 1</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Concurrent Review</span>
                            <input type='date' id='txtConReview1_DtOfConReview' name='txtConReview1_DtOfConReview' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Changes to Member Demographics</span>
                            Psychiatric Hospitalizations since last review:
                            <select id='ddlConReview1_PsyHospLstRev' name='ddlConReview1_PsyHospLstRev' className='add-only'>
                                <option value='Na'></option>
                                <option value='0'>0</option>
                                <option value='1'>1</option>
                                <option value='2'>2-3</option>
                                <option value='4'>4-5</option>
                                <option value='6'>6+</option>
                            </select>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Changes to Diagnosis</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis I</span>
                            <input type='text' id='txtConReview1_AxisI' name='txtConReview1_AxisI' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis II</span>
                            <input type='text' id='txtConReview1_AxisII' name='txtConReview1_AxisII' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis III</span>
                            <input type='text' id='txtConReview1_AxisIII' name='txtConReview1_AxisIII' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis IV</span>
                            <input type='text' id='txtConReview1_AxisIV' name='txtConReview1_AxisIV' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis V</span>
                            <input type='text' id='txtConReview1_AxisV' name='txtConReview1_AxisV' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Current Medications and Dose</span>
                    <textarea id='txtConReview1_CurMedAndDose' name='txtConReview1_CurMedAndDose' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Progress toward Treatment Goals</span>
                    <textarea id='txtConReview1_ProTowardTreatGoals' name='txtConReview1_ProTowardTreatGoals' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Identified Changes to Treatment Plan</span>
                    <textarea id='txtConReview1_IdeChanToTreatPlan' name='txtConReview1_IdeChanToTreatPlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Service Authorization Criteria for Continued Treatment</span>
                    <textarea id='txtConReview1_SerAuthCrit' name='txtConReview1_SerAuthCrit' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Units requested</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date From</span></td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date To</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview1_Act21' name='cbConReview1_Act21' className='add-only' value='Act21' /> ACT (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview1_Act21' name='txtConReview1_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1FromDt_Act21' name='txtConReview1FromDt_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1ToDt_Act21' name='txtConReview1ToDt_Act21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview1_Cpst21' name='cbConReview1_Cpst21' className='add-only' value='Cpst_21' /> CPST (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview1_Cpst21' name='txtConReview1_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1FromDt_Cpst21' name='txtConReview1FromDt_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1ToDt_Cpst21' name='txtConReview1ToDt_Cpst21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview1_Psr21Ind' name='cbConReview1_Psr21Ind' className='add-only' value='PSR (21+)-Ind' /> PSR (21+)-Ind
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview1_Psr21Ind' name='txtConReview1_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1FromDt_Psr21Ind' name='txtConReview1FromDt_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1ToDt_Psr21Ind' name='txtConReview1ToDt_Psr21Ind' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview1_Psr21Group' name='cbConReview1_Psr21Group' className='add-only' value='PSR (21+)-Group' /> PSR (21+)-Group
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview1_Psr21Group' name='txtConReview1_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1FromDt_Psr21Group' name='txtConReview1FromDt_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1ToDt_Psr21Group' name='txtConReview1ToDt_Psr21Group' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview1_Mst1217' name='cbConReview1_Mst1217' className='add-only' value='Mst' /> MST (12-17)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview1_Mst1217' name='txtConReview1_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1FromDt_Mst1217' name='txtConReview1FromDt_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1ToDt_Mst1217' name='txtConReview1ToDt_Mst1217' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            MST Consultant approval form included <input type='checkbox' id='cbConReview1_MstConsulApp' name='cbConReview1_MstConsulApp' className='add-only' value='MST Consultant approval form included' /> (If No, authorization cannot be completed.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview1_PsrLess21' name='cbConReview1_PsrLess21' className='add-only' value='CPST/PSR (<21)' /> {`CPST/PSR (<21)`}
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview1_PsrLess21' name='txtConReview1_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1FromDt_PsrLess21' name='txtConReview1FromDt_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1ToDt_PsrLess21' name='txtConReview1ToDt_PsrLess21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview1_Hbuilders18' name='cbConReview1_Hbuilders18' className='add-only' value='Hbuilders (0-18)' /> Hbuilders (0-18)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview1_Hbuilders18' name='txtConReview1_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1FromDt_Hbuilders18' name='txtConReview1FromDt_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1ToDt_Hbuilders18' name='txtConReview1ToDt_Hbuilders18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview1_Fft10' name='cbConReview1_Fft10' className='add-only' value='FFT (0-10)' /> FFT (0-10)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview1_Fft10' name='txtConReview1_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1FromDt_Fft10' name='txtConReview1FromDt_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview1ToDt_Fft10' name='txtConReview1ToDt_Fft10' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Other Notes As Appropriate</span>
                    <textarea id='txtConReview1_OthNotesAsApp' name='txtConReview1_OthNotesAsApp' className='add-only'></textarea>
                </p>

                <p className='w-750'><h4>Concurrent Review 2</h4></p>
                
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Concurrent Review</span>
                            <input type='date' id='txtConReview2_DtOfConReview' name='txtConReview2_DtOfConReview' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Changes to Member Demographics</span>
                            Psychiatric Hospitalizations since last review:
                            <select id='ddlConReview2_PsyHospLstRev' name='ddlConReview2_PsyHospLstRev' className='add-only'>
                                <option value='Na'></option>
                                <option value='0'>0</option>
                                <option value='1'>1</option>
                                <option value='2'>2-3</option>
                                <option value='4'>4-5</option>
                                <option value='6'>6+</option>
                            </select>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Changes to Diagnosis</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis I</span>
                            <input type='text' id='txtConReview2_AxisI' name='txtConReview2_AxisI' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis II</span>
                            <input type='text' id='txtConReview2_AxisII' name='txtConReview2_AxisII' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis III</span>
                            <input type='text' id='txtConReview2_AxisIII' name='txtConReview2_AxisIII' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis IV</span>
                            <input type='text' id='txtConReview2_AxisIV' name='txtConReview2_AxisIV' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis V</span>
                            <input type='text' id='txtConReview2_AxisV' name='txtConReview2_AxisV' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Current Medications and Dose</span>
                    <textarea id='txtConReview2_CurMedAndDose' name='txtConReview2_CurMedAndDose' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Progress toward Treatment Goals</span>
                    <textarea id='txtConReview2_ProTowardTreatGoals' name='txtConReview2_ProTowardTreatGoals' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Identified Changes to Treatment Plan</span>
                    <textarea id='txtConReview2_IdeChanToTreatPlan' name='txtConReview2_IdeChanToTreatPlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Service Authorization Criteria for Continued Treatment</span>
                    <textarea id='txtConReview2_SerAuthCrit' name='txtConReview2_SerAuthCrit' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Units requested</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date From</span></td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date To</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview2_Act21' name='cbConReview2_Act21' className='add-only' value='Act21' /> ACT (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview2_Act21' name='txtConReview2_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2FromDt_Act21' name='txtConReview2FromDt_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2ToDt_Act21' name='txtConReview2ToDt_Act21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview2_Cpst21' name='cbConReview2_Cpst21' className='add-only' value='Cpst_21' /> CPST (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview2_Cpst21' name='txtConReview2_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2FromDt_Cpst21' name='txtConReview2FromDt_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2ToDt_Cpst21' name='txtConReview2ToDt_Cpst21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview2_Psr21Ind' name='cbConReview2_Psr21Ind' className='add-only' value='PSR (21+)-Ind' /> PSR (21+)-Ind
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview2_Psr21Ind' name='txtConReview2_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2FromDt_Psr21Ind' name='txtConReview2FromDt_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2ToDt_Psr21Ind' name='txtConReview2ToDt_Psr21Ind' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview2_Psr21Group' name='cbConReview2_Psr21Group' className='add-only' value='PSR (21+)-Group' /> PSR (21+)-Group
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview2_Psr21Group' name='txtConReview2_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2FromDt_Psr21Group' name='txtConReview2FromDt_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2ToDt_Psr21Group' name='txtConReview2ToDt_Psr21Group' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview2_Mst1217' name='cbConReview2_Mst1217' className='add-only' value='Mst' /> MST (12-17)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview2_Mst1217' name='txtConReview2_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2FromDt_Mst1217' name='txtConReview2FromDt_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2ToDt_Mst1217' name='txtConReview2ToDt_Mst1217' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            MST Consultant approval form included <input type='checkbox' id='cbConReview2_MstConsulApp' name='cbConReview2_MstConsulApp' className='add-only' value='MST Consultant approval form included' /> (If No, authorization cannot be completed.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview2_PsrLess21' name='cbConReview2_PsrLess21' className='add-only' value='CPST/PSR (<21)' /> {`CPST/PSR (<21)`}
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview2_PsrLess21' name='txtConReview2_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2FromDt_PsrLess21' name='txtConReview2FromDt_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2ToDt_PsrLess21' name='txtConReview2ToDt_PsrLess21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview2_Hbuilders18' name='cbConReview2_Hbuilders18' className='add-only' value='Hbuilders (0-18)' /> Hbuilders (0-18)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview2_Hbuilders18' name='txtConReview2_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2FromDt_Hbuilders18' name='txtConReview2FromDt_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2ToDt_Hbuilders18' name='txtConReview2ToDt_Hbuilders18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview2_Fft10' name='cbConReview2_Fft10' className='add-only' value='FFT (0-10)' /> FFT (0-10)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview2_Fft10' name='txtConReview2_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2FromDt_Fft10' name='txtConReview2FromDt_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview2ToDt_Fft10' name='txtConReview2ToDt_Fft10' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Other Notes As Appropriate</span>
                    <textarea id='txtConReview2_OthNotesAsApp' name='txtConReview2_OthNotesAsApp' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Concurrent Review 3</h4></p>
                
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Concurrent Review</span>
                            <input type='date' id='txtConReview3_DtOfConReview' name='txtConReview3_DtOfConReview' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Changes to Member Demographics</span>
                            Psychiatric Hospitalizations since last review:
                            <select id='ddlConReview3_PsyHospLstRev' name='ddlConReview3_PsyHospLstRev' className='add-only'>
                                <option value='Na'></option>
                                <option value='0'>0</option>
                                <option value='1'>1</option>
                                <option value='2'>2-3</option>
                                <option value='4'>4-5</option>
                                <option value='6'>6+</option>
                            </select>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Changes to Diagnosis</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis I</span>
                            <input type='text' id='txtConReview3_AxisI' name='txtConReview3_AxisI' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis II</span>
                            <input type='text' id='txtConReview3_AxisII' name='txtConReview3_AxisII' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis III</span>
                            <input type='text' id='txtConReview3_AxisIII' name='txtConReview3_AxisIII' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis IV</span>
                            <input type='text' id='txtConReview3_AxisIV' name='txtConReview3_AxisIV' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis V</span>
                            <input type='text' id='txtConReview3_AxisV' name='txtConReview3_AxisV' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Current Medications and Dose</span>
                    <textarea id='txtConReview3_CurMedAndDose' name='txtConReview3_CurMedAndDose' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Progress toward Treatment Goals</span>
                    <textarea id='txtConReview3_ProTowardTreatGoals' name='txtConReview3_ProTowardTreatGoals' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Identified Changes to Treatment Plan</span>
                    <textarea id='txtConReview3_IdeChanToTreatPlan' name='txtConReview3_IdeChanToTreatPlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Service Authorization Criteria for Continued Treatment</span>
                    <textarea id='txtConReview3_SerAuthCrit' name='txtConReview3_SerAuthCrit' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Units requested</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date From</span></td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date To</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview3_Act21' name='cbConReview3_Act21' className='add-only' value='Act21' /> ACT (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview3_Act21' name='txtConReview3_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3FromDt_Act21' name='txtConReview3FromDt_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3ToDt_Act21' name='txtConReview3ToDt_Act21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview3_Cpst21' name='cbConReview3_Cpst21' className='add-only' value='Cpst_21' /> CPST (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview3_Cpst21' name='txtConReview3_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3FromDt_Cpst21' name='txtConReview3FromDt_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3ToDt_Cpst21' name='txtConReview3ToDt_Cpst21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview3_Psr21Ind' name='cbConReview3_Psr21Ind' className='add-only' value='PSR (21+)-Ind' /> PSR (21+)-Ind
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview3_Psr21Ind' name='txtConReview3_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3FromDt_Psr21Ind' name='txtConReview3FromDt_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3ToDt_Psr21Ind' name='txtConReview3ToDt_Psr21Ind' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview3_Psr21Group' name='cbConReview3_Psr21Group' className='add-only' value='PSR (21+)-Group' /> PSR (21+)-Group
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview3_Psr21Group' name='txtConReview3_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3FromDt_Psr21Group' name='txtConReview3FromDt_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3ToDt_Psr21Group' name='txtConReview3ToDt_Psr21Group' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview3_Mst1217' name='cbConReview3_Mst1217' className='add-only' value='Mst' /> MST (12-17)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview3_Mst1217' name='txtConReview3_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3FromDt_Mst1217' name='txtConReview3FromDt_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3ToDt_Mst1217' name='txtConReview3ToDt_Mst1217' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            MST Consultant approval form included <input type='checkbox' id='cbConReview3_MstConsulApp' name='cbConReview3_MstConsulApp' className='add-only' value='MST Consultant approval form included' /> (If No, authorization cannot be completed.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview3_PsrLess21' name='cbConReview3_PsrLess21' className='add-only' value='CPST/PSR (<21)' /> {`CPST/PSR (<21)`}
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview3_PsrLess21' name='txtConReview3_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3FromDt_PsrLess21' name='txtConReview3FromDt_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3ToDt_PsrLess21' name='txtConReview3ToDt_PsrLess21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview3_Hbuilders18' name='cbConReview3_Hbuilders18' className='add-only' value='Hbuilders (0-18)' /> Hbuilders (0-18)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview3_Hbuilders18' name='txtConReview3_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3FromDt_Hbuilders18' name='txtConReview3FromDt_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3ToDt_Hbuilders18' name='txtConReview3ToDt_Hbuilders18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview3_Fft10' name='cbConReview3_Fft10' className='add-only' value='FFT (0-10)' /> FFT (0-10)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview3_Fft10' name='txtConReview3_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3FromDt_Fft10' name='txtConReview3FromDt_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview3ToDt_Fft10' name='txtConReview3ToDt_Fft10' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Other Notes As Appropriate</span>
                    <textarea id='txtConReview3_OthNotesAsApp' name='txtConReview3_OthNotesAsApp' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Concurrent Review 4</h4></p>
                
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Concurrent Review</span>
                            <input type='date' id='txtConReview4_DtOfConReview' name='txtConReview4_DtOfConReview' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Changes to Member Demographics</span>
                            Psychiatric Hospitalizations since last review:
                            <select id='ddlConReview4_PsyHospLstRev' name='ddlConReview4_PsyHospLstRev' className='add-only'>
                                <option value='Na'></option>
                                <option value='0'>0</option>
                                <option value='1'>1</option>
                                <option value='2'>2-3</option>
                                <option value='4'>4-5</option>
                                <option value='6'>6+</option>
                            </select>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Changes to Diagnosis</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis I</span>
                            <input type='text' id='txtConReview4_AxisI' name='txtConReview4_AxisI' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis II</span>
                            <input type='text' id='txtConReview4_AxisII' name='txtConReview4_AxisII' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis III</span>
                            <input type='text' id='txtConReview4_AxisIII' name='txtConReview4_AxisIII' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis IV</span>
                            <input type='text' id='txtConReview4_AxisIV' name='txtConReview4_AxisIV' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis V</span>
                            <input type='text' id='txtConReview4_AxisV' name='txtConReview4_AxisV' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Current Medications and Dose</span>
                    <textarea id='txtConReview4_CurMedAndDose' name='txtConReview4_CurMedAndDose' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Progress toward Treatment Goals</span>
                    <textarea id='txtConReview4_ProTowardTreatGoals' name='txtConReview4_ProTowardTreatGoals' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Identified Changes to Treatment Plan</span>
                    <textarea id='txtConReview4_IdeChanToTreatPlan' name='txtConReview4_IdeChanToTreatPlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Service Authorization Criteria for Continued Treatment</span>
                    <textarea id='txtConReview4_SerAuthCrit' name='txtConReview4_SerAuthCrit' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Units requested</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date From</span></td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date To</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview4_Act21' name='cbConReview4_Act21' className='add-only' value='Act21' /> ACT (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview4_Act21' name='txtConReview4_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4FromDt_Act21' name='txtConReview4FromDt_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4ToDt_Act21' name='txtConReview4ToDt_Act21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview4_Cpst21' name='cbConReview4_Cpst21' className='add-only' value='Cpst_21' /> CPST (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview4_Cpst21' name='txtConReview4_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4FromDt_Cpst21' name='txtConReview4FromDt_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4ToDt_Cpst21' name='txtConReview4ToDt_Cpst21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview4_Psr21Ind' name='cbConReview4_Psr21Ind' className='add-only' value='PSR (21+)-Ind' /> PSR (21+)-Ind
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview4_Psr21Ind' name='txtConReview4_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4FromDt_Psr21Ind' name='txtConReview4FromDt_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4ToDt_Psr21Ind' name='txtConReview4ToDt_Psr21Ind' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview4_Psr21Group' name='cbConReview4_Psr21Group' className='add-only' value='PSR (21+)-Group' /> PSR (21+)-Group
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview4_Psr21Group' name='txtConReview4_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4FromDt_Psr21Group' name='txtConReview4FromDt_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4ToDt_Psr21Group' name='txtConReview4ToDt_Psr21Group' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview4_Mst1217' name='cbConReview4_Mst1217' className='add-only' value='Mst' /> MST (12-17)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview4_Mst1217' name='txtConReview4_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4FromDt_Mst1217' name='txtConReview4FromDt_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4ToDt_Mst1217' name='txtConReview4ToDt_Mst1217' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            MST Consultant approval form included <input type='checkbox' id='cbConReview4_MstConsulApp' name='cbConReview4_MstConsulApp' className='add-only' value='MST Consultant approval form included' /> (If No, authorization cannot be completed.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview4_PsrLess21' name='cbConReview4_PsrLess21' className='add-only' value='CPST/PSR (<21)' /> {`CPST/PSR (<21)`}
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview4_PsrLess21' name='txtConReview4_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4FromDt_PsrLess21' name='txtConReview4FromDt_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4ToDt_PsrLess21' name='txtConReview4ToDt_PsrLess21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview4_Hbuilders18' name='cbConReview4_Hbuilders18' className='add-only' value='Hbuilders (0-18)' /> Hbuilders (0-18)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview4_Hbuilders18' name='txtConReview4_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4FromDt_Hbuilders18' name='txtConReview4FromDt_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4ToDt_Hbuilders18' name='txtConReview4ToDt_Hbuilders18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview4_Fft10' name='cbConReview4_Fft10' className='add-only' value='FFT (0-10)' /> FFT (0-10)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview4_Fft10' name='txtConReview4_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4FromDt_Fft10' name='txtConReview4FromDt_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview4ToDt_Fft10' name='txtConReview4ToDt_Fft10' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Other Notes As Appropriate</span>
                    <textarea id='txtConReview4_OthNotesAsApp' name='txtConReview4_OthNotesAsApp' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Concurrent Review 5</h4></p>
                
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Concurrent Review</span>
                            <input type='date' id='txtConReview5_DtOfConReview' name='txtConReview5_DtOfConReview' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Changes to Member Demographics</span>
                            Psychiatric Hospitalizations since last review:
                            <select id='ddlConReview5_PsyHospLstRev' name='ddlConReview5_PsyHospLstRev' className='add-only'>
                                <option value='Na'></option>
                                <option value='0'>0</option>
                                <option value='1'>1</option>
                                <option value='2'>2-3</option>
                                <option value='4'>4-5</option>
                                <option value='6'>6+</option>
                            </select>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Changes to Diagnosis</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis I</span>
                            <input type='text' id='txtConReview5_AxisI' name='txtConReview5_AxisI' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis II</span>
                            <input type='text' id='txtConReview5_AxisII' name='txtConReview5_AxisII' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis III</span>
                            <input type='text' id='txtConReview5_AxisIII' name='txtConReview5_AxisIII' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis IV</span>
                            <input type='text' id='txtConReview5_AxisIV' name='txtConReview5_AxisIV' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis V</span>
                            <input type='text' id='txtConReview5_AxisV' name='txtConReview5_AxisV' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Current Medications and Dose</span>
                    <textarea id='txtConReview5_CurMedAndDose' name='txtConReview5_CurMedAndDose' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Progress toward Treatment Goals</span>
                    <textarea id='txtConReview5_ProTowardTreatGoals' name='txtConReview5_ProTowardTreatGoals' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Identified Changes to Treatment Plan</span>
                    <textarea id='txtConReview5_IdeChanToTreatPlan' name='txtConReview5_IdeChanToTreatPlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Service Authorization Criteria for Continued Treatment</span>
                    <textarea id='txtConReview5_SerAuthCrit' name='txtConReview5_SerAuthCrit' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Units requested</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date From</span></td>
                        <td className='w-187'><span className='eleHeader'>Treatment Date To</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview5_Act21' name='cbConReview5_Act21' className='add-only' value='Act21' /> ACT (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview5_Act21' name='txtConReview5_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5FromDt_Act21' name='txtConReview5FromDt_Act21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5ToDt_Act21' name='txtConReview5ToDt_Act21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview5_Cpst21' name='cbConReview5_Cpst21' className='add-only' value='Cpst_21' /> CPST (21+)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview5_Cpst21' name='txtConReview5_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5FromDt_Cpst21' name='txtConReview5FromDt_Cpst21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5ToDt_Cpst21' name='txtConReview5ToDt_Cpst21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview5_Psr21Ind' name='cbConReview5_Psr21Ind' className='add-only' value='PSR (21+)-Ind' /> PSR (21+)-Ind
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview5_Psr21Ind' name='txtConReview5_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5FromDt_Psr21Ind' name='txtConReview5FromDt_Psr21Ind' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5ToDt_Psr21Ind' name='txtConReview5ToDt_Psr21Ind' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview5_Psr21Group' name='cbConReview5_Psr21Group' className='add-only' value='PSR (21+)-Group' /> PSR (21+)-Group
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview5_Psr21Group' name='txtConReview5_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5FromDt_Psr21Group' name='txtConReview5FromDt_Psr21Group' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5ToDt_Psr21Group' name='txtConReview5ToDt_Psr21Group' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview5_Mst1217' name='cbConReview5_Mst1217' className='add-only' value='Mst' /> MST (12-17)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview5_Mst1217' name='txtConReview5_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5FromDt_Mst1217' name='txtConReview5FromDt_Mst1217' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5ToDt_Mst1217' name='txtConReview5ToDt_Mst1217' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            MST Consultant approval form included <input type='checkbox' id='cbConReview5_MstConsulApp' name='cbConReview5_MstConsulApp' className='add-only' value='MST Consultant approval form included' /> (If No, authorization cannot be completed.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview5_PsrLess21' name='cbConReview5_PsrLess21' className='add-only' value='CPST/PSR (<21)' /> {`CPST/PSR (<21)`}
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview5_PsrLess21' name='txtConReview5_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5FromDt_PsrLess21' name='txtConReview5FromDt_PsrLess21' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5ToDt_PsrLess21' name='txtConReview5ToDt_PsrLess21' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview5_Hbuilders18' name='cbConReview5_Hbuilders18' className='add-only' value='Hbuilders (0-18)' /> Hbuilders (0-18)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview5_Hbuilders18' name='txtConReview5_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5FromDt_Hbuilders18' name='txtConReview5FromDt_Hbuilders18' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5ToDt_Hbuilders18' name='txtConReview5ToDt_Hbuilders18' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbConReview5_Fft10' name='cbConReview5_Fft10' className='add-only' value='FFT (0-10)' /> FFT (0-10)
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtConReview5_Fft10' name='txtConReview5_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5FromDt_Fft10' name='txtConReview5FromDt_Fft10' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtConReview5ToDt_Fft10' name='txtConReview5ToDt_Fft10' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Other Notes As Appropriate</span>
                    <textarea id='txtConReview5_OthNotesAsApp' name='txtConReview5_OthNotesAsApp' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











